import { DownloadLightIcon } from '@global-engineering-shared/gweb-global-icons';
import { Button, Typography } from '@global-engineering-shared/gweb-material-ui';

import useStyles from 'features/Frames/components/Frames/FramesTable/components/FrameCsvExportButton/FrameCsvExportButton.styles';
import { State } from 'features/Frames/types';
import { useDownloadFile } from 'hooks/useDownloadFile';
import { addFiltersToUrl } from 'utils/addFiltersToUrl';
import { FRAMES_API_URL } from 'utils/environmentVariables';

export type FrameCsvExportButtonProps = {
  state?: State;
  searchParams: URLSearchParams;
};

const FrameCsvExportButton = ({ state, searchParams }: FrameCsvExportButtonProps) => {
  const { downloadFile, isLoading } = useDownloadFile();
  const classes = useStyles({ isLoading: isLoading });

  const handleDownload = async () => {
    const url = addFiltersToUrl(`${FRAMES_API_URL}/export`, searchParams, 'status', state);
    if (!isLoading) {
      await downloadFile(url);
    }
  };

  return (
    <Button
      disabled={isLoading}
      onClick={() => handleDownload()}
      variant="outlined"
      className={classes.root}
    >
      <DownloadLightIcon data-testid="download-light-icon" className={classes.icon} />
      <Typography className={classes.text}>CSV</Typography>
    </Button>
  );
};

export default FrameCsvExportButton;
